module.exports = __webpack_public_path__ + "img/education-startup.0f0cca03.png";